import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the filter panel to search orders by <strong>order ID</strong>, <strong>date range</strong>, <strong>status</strong>, <strong>country</strong>, <strong>license type</strong>, <strong>customer ID</strong>, or <strong>PO number</strong>." id="use_the_filter_panel_to_search_orders_by.0435a636" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Searching Orders" id="searching_orders.ca7d9488" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Toggle between <strong>Sent</strong> and <strong>Received</strong> views to see orders you have dispatched or orders you have received from other partners." id="toggle_between_sent_and_received_views_t.f0bf8909" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Sent vs. Received" id="sent_vs_received.2d304a96" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Click an order row to open the <strong>details dialog</strong>, where you can view the full order information and line items." id="click_an_order_row_to_open_the_details_d.a7f36441" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Order Details" id="order_details.f1808d77" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the <strong>cancel</strong> action on an order to revoke it. This action may be restricted based on the order's current status." id="use_the_cancel_action_on_an_order_to_rev.6baec9e4" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Cancelling Orders" id="cancelling_orders.d780792b" />
        }
    ],
    title: <FormattedMessage defaultMessage="Order History" id="order_history.8a7d4817" />
};
